import React, { useEffect, useState } from 'react'
import ApiService from '../../../service/ApiService'
import { useForm } from 'react-hook-form'
import { apiPaths } from '../../../service/apiPaths'
import { useNavigate, useLocation } from 'react-router-dom'
import toast from 'react-hot-toast'

const useEdit = () => {
    const [loading, setLoading] = useState<boolean>(false)
    const { handleSubmit } = useForm()
    const navigate = useNavigate()
    const location = useLocation()
    const [upload, setUpload] = useState<string|null>(null)
    const [getUpload, setGetUpload] = useState<string|null>(null)
    
    // Build complete return URL with all filters from current location
    const buildReturnURL = () => {
        // Read directly from location.search to get all params
        const currentParams = new URLSearchParams(location.search)
        
        console.log("=== BUILDING RETURN URL ===")
        console.log("Current location.search:", location.search)
        console.log("All params from URL:")
        currentParams.forEach((value, key) => {
            console.log(`  ${key}: ${value}`)
        })
        
        const returnURL = `/hiring?${currentParams.toString()}`
        console.log("Built return URL:", returnURL)
        return returnURL
    }

    const uploadResume = async (file: File) => {
        const formData = new FormData();
        formData.append("resume", file);

        try {
            const result = await ApiService({
                method: "POST",
                endpoint: apiPaths.uploadResume,
                data: formData,
                headers: { "Content-Type": "multipart/form-data" },
            });
            const url = result?.resumeUrl || result?.fileUrl || result?.url;
            if (url) {
                setUpload(url);
                toast.success("Resume uploaded successfully");
                return url;
            }
            return null; 
        } catch (error) {
            console.error("Error uploading resume:", error);
            toast.error("Resume upload failed");
            return null;
        }
    };

    const onSubmit = async (id: string, data: any) => {
        setLoading(true);
        try {
            console.log("Submitting data:", data);
            
            // Don't use FormData - send as JSON
            const result = await ApiService({
                method: "PUT",
                endpoint: `${apiPaths.editHiring}${id}`,
                data: data,
            });
            
            console.log("Update result:", result);
            
            if (result.success || result.message) {
                toast.success("Hiring data updated successfully");
                // Navigate back with all filters preserved
                navigate(buildReturnURL());
            } else {
                console.error("Edit failed:", result);
                toast.error("Failed to update hiring data");
            }
        } catch (error: any) {
            console.error("Error editing hiring:", error);
            toast.error(error?.response?.data?.message || "Error updating hiring data");
        } finally {
            setLoading(false);
        }
    }

    return { loading, onSubmit, handleSubmit, uploadResume, upload }
}

export default useEdit